import { memo } from "react";
import { ECommerce } from "ui/organizms/Onboarding";

const PaymentMethods = () => (
    <ECommerce.PaymentMethods />
);

export default memo(PaymentMethods);
